import PrintsPage from './PrintsPage';

export default PrintsPage;
